/**
 * This hook is used to fetch the data for the second view (see also `Frontend#prepareLazyLoad`).
 * It also ensures that this hook can be used on multiple instances (e.g. Cookie Banner and Content Blocker)
 * by not fetching the data multiple times.
 */ function getLazyDataForSecondView(fetcher, hasLazyData) {
    const lazyPromise = window.rcbLazyPromise;
    let resolver;
    let promise;
    if (!lazyPromise) {
        let resolved = false;
        if (hasLazyData === false) {
            promise = Promise.resolve({});
        } else {
            promise = new Promise((resolve)=>{
                resolver = async ()=>{
                    if (resolved) {
                        return;
                    }
                    resolved = true;
                    resolve(await fetcher());
                };
            });
        }
    } else {
        [promise, resolver] = lazyPromise;
    }
    return [
        promise,
        resolver
    ];
}
export { getLazyDataForSecondView };
